import { render, staticRenderFns } from "./voteshow_1.vue?vue&type=template&id=9d6b434c"
import script from "./voteshow_1.vue?vue&type=script&lang=js"
export * from "./voteshow_1.vue?vue&type=script&lang=js"
import style0 from "./voteshow_1.vue?vue&type=style&index=0&id=9d6b434c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports